import { createFeatureSelector } from '@ngrx/store';

import { SCAN_FEATURE_KEY } from './constants';
import { State } from './models';
export const selectScanState = createFeatureSelector<State>(SCAN_FEATURE_KEY);
